export const en = {
  // ==================== PERSONAL INFO ====================
  personal: {
    firstName: "Panagiotis",
    lastName: "Bekos",
    fullName: "Panagiotis Bekos",
    profession: "Woodcarver",
    bio: `My approach to this tradition is one of study and apprenticeship in the works of great woodcarvers,
    whose creations reveal knowledge, experience, sensitivity, and high craftsmanship. Often, their work reflects the
    living ecclesiastical experience captured in the lifeless material, as much as this is possible.`,
  },

  // ==================== CONTACT INFO ====================
  contact: {
    email: "p9bekos@gmail.com",
    phone: "+30 6936881488",
    address: {
      street: "Aristotelous 23",
      city: "Helioupoli",
      postalCode: "16343",
      country: "Greece",
    },
    social: {
      facebook: "https://www.facebook.com/your-page",
      instagram: "https://www.instagram.com/your-account",
    },
  },

  // ==================== HEADER ====================
  header: {
    woodcarverName: "Panagiotis",
    woodcarverSurname: "Bekos",
    woodcarverSpeciality: "Woodcarver",
    main: "Home",
    gallery: "Creations",
    about: "The Workshop",
    contact: "Contact"
  },

  // ==================== FOOTER ====================
  footer: {
    woodcarverFullName: "Panagiotis Bekos",
    description: "Woodcarver",
    main: "Home",
    gallery: "Creations",
    about: "The Workshop",
    contact: "Contact"
  },

  // ==================== MAIN PAGE ====================
  main: {
    heroTitle: "Woodcarving",
    heroSubtitle: "The art that carves stories into the heart of wood",
    gallerySubtitle: "CATEGORIES",
    galleryTitle: "Creations",
    textToGallery: "Discover all my creations",
    buttonToGallery: "View the collection",
    contactSubtitle: "CONTACT",
    contactTitle: "Get in touch with me",
    footerImageText: "\"…and let the beauty of the Lord our God be upon us, and establish the work of our hands upon us; yes, establish the work of our hands.\" - Psalm 89:17"
  },

  // ==================== GALLERY PAGE ====================
  gallery: {
    heroTitle: "Woodcarving Art",
    heroSubtitle: "Woodcarved artworks made with passion and love for tradition",
    title: "Creations",
    subtitle: "CATEGORIES",
    category: "CATEGORY",
    footerImageText: "\"Whatever you do, work heartily, as for the Lord and not for men\" - Colossians 3:23",
    return: "← Back to categories",
    notAvailable: "This category is not available yet",
  },

  // ==================== ABOUT PAGE ====================
  about: {
    heroTitle: "Woodcarving Workshop",
    heroSubtitle: "The place where the art of woodcarving comes to life",
    title: "Our Workshop",
    subtitle: "HISTORY",
    aboutMeTitle: "About me", // eslint-disable-next-line
    aboutMeText: "My approach to this tradition is one of study and apprenticeship based on the works of great woodcarvers, \
                which reveal knowledge, experience, sensitivity, high technique, and which are often the imprint of ecclesiastical \
                experience on inanimate material, as much as possible.",
    woodcarverFullName: "Panagiotis Bekos",
    woodcarverSpeciality: "Woodcarver",
    footerImageText: "\"For we are His workmanship, created in Christ Jesus for good works\" - Ephesians 2:10"
  },

  // ==================== CONTACT PAGE ====================
  contactPage: {
    heroTitle: "Contact",
    heroSubtitle: "Get in touch with me for more information",
    title: "Contact me",
    subtitle: "CONTACT",
    contactInfoTitle: "Contact Details",
    phoneTitle: "PHONE",
    addressTitle: "ADDRESS",
    followMe: "FOLLOW ME",
    quickMessageTitle: "Quick Message",
    quickMessageText: "Send me a short message and I will contact you soon",
    nameTitle: "Name",
    namePlaceholder: "Your name",
    messageTitle: "Message",
    messagePlaceholder: "Write your message...",
    messageButton: "Send message",
    messageSending: "Sending...",
    messageSent: "Sent!",
    messageSuccess: "Thank you! I will contact you soon.",
    footerImageText: "\"…look upon Your servants and upon Your works, and guide their children\" - Psalm 89:16"
  },

  // ==================== CATEGORIES ====================
  categories: {
    main: "Home",
    gallery: "Creations",
    about: "The Workshop",
    contact: "Contact",
    agies_trapezes: "Holy Altars",
    amvones: "Pulpits",
    analogia: "Chanter Stands", // Also known as Analoy/Analogion
    artoforia: "Artophory",
    despotikoi_thronoi: "Bishop Thrones",
    diafora: "Miscellaneous",
    diskelia: "Folding Stools",
    epipla: "Furniture",
    epitafioi: "Epitaphios Shrines",
    filoptoha: "Alms Boxes",
    kornizes: "Frames",
    lipsanothikes: "Reliquaries",
    kirothikes: "Donation Boxes",
    polithrones: "Armchairs",
    portes: "Doors",
    proskinitaria: "Icon Stands",
    prothikes: "Showcases",
    stasidia_karekles: "Choir Stalls - Chairs",
    stavroi: "Crosses",
    stefanothikes: "Wreath Boxes",
    templa: "Iconostases",
    trapezia: "Tables",
    vimothira: "Altar Doors",
  },

  categoriesNoTones: {
    main: "Home",
    gallery: "Creations",
    about: "The Workshop",
    contact: "Contact",
    agies_trapezes: "Holy Altars",
    amvones: "Pulpits",
    analogia: "Chanter Stands", // Also known as Analoy/Analogion
    artoforia: "Artophory",
    despotikoi_thronoi: "Bishop Thrones",
    diafora: "Miscellaneous",
    diskelia: "Folding Stools",
    epipla: "Furniture",
    epitafioi: "Epitaphios Shrines",
    filoptoha: "Alms Boxes",
    kornizes: "Frames",
    lipsanothikes: "Reliquaries",
    kirothikes: "Donation Boxes",
    polithrones: "Armchairs",
    portes: "Doors",
    proskinitaria: "Icon Stands",
    prothikes: "Showcases",
    stasidia_karekles: "Choir Stalls - Chairs",
    stavroi: "Crosses",
    stefanothikes: "Wreath Boxes",
    templa: "Iconostases",
    trapezia: "Tables",
    vimothira: "Altar Doors",
  },

  // ==================== MESSAGES ====================
  messages: {
    emailCopied: "Email copied!",
    phoneCopied: "Phone number copied!",
    nameRequired: "Name is required.",
    emailRequired: "Email is required.",
    nameInvalid: "The name contains invalid characters.",
    emailInvalid: "Invalid email.",
    messageRequired: "Message is required.",
    sendFailed: "Sending failed. Please try again.",
  }
};
